import Widget from 'portaltransparencia-common/components/Widget.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

export class FormSelo extends Component {
  static propTypes = {
    certificado: PropTypes.object
  };

  componentDidMount() {}

  render() {
    const { certificado } = this.props;
    let dataAvaliacaoSelo = DateUtils.formatDateTimeShort(
      certificado.get('seloDataAvaliacao')
    );
    let selo = certificado.get('selo');
    return (
      <div>
        <Widget
          icon="fa fa-certificate"
          title={'Certificado de Qualidade em Transparência Publica'}
          noGradientBackground
        >
          <Row>
            <Col sm={4} md={4}>
              <article className="widget-numeric block">
                <b className="widget-numeric-number">{dataAvaliacaoSelo}</b>
                <div className="widget-numeric-subtitle">Data da Avaliação</div>
              </article>
            </Col>
            <Col sm={4} md={4}>
              <article className="widget-numeric block">
                <b className="widget-numeric-number">
                  {certificado.get('seloProcessoTCE')}
                </b>
                <p className="widget-numeric-subtitle">Processo TCE</p>
              </article>
            </Col>
            <Col sm={4} md={4}>
              <article className="widget-numeric block">
                <b className="widget-numeric-number">
                  {certificado.get('seloNotaObtida') + '%'}
                </b>
                <div className="widget-numeric-subtitle">Nota Obtida</div>
              </article>
            </Col>
          </Row>
          <Row className="mt-xs">
            <Col sm={4} smOffset={4}>
              <img
                className="img-responsive mt-xs"
                src={`data:image/*;base64,${selo}`}
              />
            </Col>
          </Row>
        </Widget>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    certificado: state.entidade.get('configuracoesGerais')
  };
}

export default connect(mapStateToProps)(FormSelo);
